module.exports = __webpack_public_path__ + "media/stylesheets/opensansi800-949ced291b0e30a2246fe57f9f48246a.woff";